import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import { mealGroupEditModalStore } from '../../store/mealGroupEditModalStore';
import { localeStore } from '~/mobx/localesStore';
import MultiLanguageInput from '~/view/components/Controls/MultiLanguageInput/MultiLanguageInput';
import Text from '~/view/components/Text/Text';

export const MealGroupEditModalForm: FC = memo(
  observer((): ReactElement => {
    return (
      <form className="meal-edit-modal__form" onSubmit={mealGroupEditModalStore.onSubmit}>
        <Text type="block-header" text="name" required />

        <MultiLanguageInput
          enText={mealGroupEditModalStore.name.en}
          arText={mealGroupEditModalStore.name.ar}
          validation={mealGroupEditModalStore.validation}
          placeholder={localeStore.t('mc_group_name')}
          onChangeValue={mealGroupEditModalStore.onChangeName}
          className="full-width mt-2"
        />
      </form>
    );
  })
);
